<template>
  <div>
   <CRow>
      <CCol>

        <CTableWrapper
          :items=orderListApprove
          :fields=this.fields
          :items-per-page=100
          @order-change-amount="orderChangeAmount"
          hover
          striped
          bordered
          small
          fixed
          sorter
          approve
          caption = "Wunschliste"
        />
        
        <CBadge v-if="cartDiff" id="badgeShipingFee" style="display:block;padding: 1em; margin-bottom:1em;" color="warning">Bestellwert: {{cartSum}} €. Bestellen Sie noch für {{cartDiff}} € um versandkostenfrei zu sein.</CBadge>
          <CBadge v-else id="badgeShipingFee" style="display:block;padding: 1em; margin-bottom:1em;" color="success">Bestellwert: {{cartSum}} €. Sie bestellen versandkostenfrei!.</CBadge>

        <button type="button" class="btn btn-success" @click="onApproveAll">Alle Freigeben</button>
        
        <button type="button" class="btn btn-success" @click="onOrderCart" style="margin-left: 1em;">Warenkorb bestellen</button>
          
      </CCol>
    </CRow>
 
  </div>
  
</template>
<script>
  import CTableWrapper from './Table.vue'
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: 'Approve',
    components: { CTableWrapper },
    
    
    data() {
      return {
      
        fields:  [
          {key:'articleno',label:'Artikel',sorter:true},
          {key:'price',label:'Preis',sorter:true},
          {key:'amount',label:'Menge',sorter:true},
          {key:'functions',label:'',sorter:false},
          {key:'status',label:'Status',sorter:true},
          {key:'order_time',label:'Bestelldatum',sorter:true}
           
        ]        

      };
    },
    computed : mapGetters(["orderListApprove","cartSum","cartDiff","profile"]),
    created() {
      var id;
      if (this.profile.parent > 0 ) {
        id = this.profile.parent;
      } else {
        id = this.profile.id;
      }
      this.getOrderListApprove( {orderUserID:id} ); 
     
    },
    methods: {
      ...mapActions(['getOrderListApprove','orderChangeAmount','orderApproveAll','orderCart','setOrderListSearchtext']),
      
      onOrderCart() {

        if (confirm('Möchten Sie wirklich den Warenkorb Bestellen?')) {
          this.orderCart();
        }  

      },

      onApproveAll(){ 
      
        if (confirm('Möchten Sie wirklich alle Bestellungen Freigeben?')) {

          let list = []; 
          this.orderListApprove.map(function(value, key) {  list.push(value.id); });
          var ids = list.join(",");
          this.orderApproveAll(ids);
        }  
      
      }

    }
  }
</script>
